<template>
  <tr class="add-contact-row">
    <td v-if="isAdding" class="holder-checkbox" />
    <td v-if="isAdding">
      <div class="holder-info">
        <div class="info">
          <div class="editable-cell-container">
            <div class="group-selection-container">
              <CustomSelect
                :options="formattedExistingGroups"
                placeholder="Select a group"
                :is-invalid="nameInvalid"
                :add-input="true"
                @input="onGroupSelect"
                @addNew="onAddNewGroup"
              />
            </div>
          </div>
        </div>
      </div>
    </td>
    <td v-if="isAdding">
      <div class="holder-info">
        <div class="info">
          <div class="editable-cell-container">
            <CustomInput
              :model-value="newContact.countryCode"
              placeholder="Country code"
              input-type="digitsAndPlus"
              @update:modelValue="updateNewContact('countryCode', $event)"
              @keyup:enter="saveNewContact"
              @keyup:esc="resetAddingNewContact"
            />
          </div>
        </div>
      </div>
    </td>
    <td v-if="isAdding">
      <div class="holder-info">
        <div class="info">
          <div class="editable-cell-container">
            <CustomInput
              :model-value="newContact.phoneNumber"
              placeholder="Phone Number"
              input-type="digits"
              :is-invalid="phoneInvalid"
              @update:modelValue="updateNewContact('phoneNumber', $event)"
              @keyup:enter="saveNewContact"
              @keyup:esc="resetAddingNewContact"
            />
          </div>
        </div>
      </div>
    </td>
    <td v-if="isAdding">
      <div class="holder-info">
        <div class="info">
          <div class="editable-cell-container">
            <CustomInput
              :model-value="newContact.email"
              placeholder="Email"
              :is-invalid="emailInvalid"
              @update:modelValue="updateNewContact('email', $event)"
              @keyup:enter="saveNewContact"
              @keyup:esc="resetAddingNewContact"
            />
          </div>
        </div>
      </div>
    </td>
    <td v-if="isAdding">
      <div class="holder-info">
        <div class="info">
          <div class="editable-cell-container">
            <CustomInput
              :model-value="newContact.note"
              placeholder="Notes"
              @update:modelValue="updateNewContact('note', $event)"
              @keyup:enter="saveNewContact"
              @keyup:esc="resetAddingNewContact"
            />
          </div>
        </div>
      </div>
    </td>
    <td v-if="isAdding">
      <div class="actions-container">
        <button class="save-btn" title="Save" @click="saveNewContact">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.7071 4.29289C14.0976 4.68342 14.0976 5.31658 13.7071 5.70711L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071L2.29289 9.70711C1.90237 9.31658 1.90237 8.68342 2.29289 8.29289C2.68342 7.90237 3.31658 7.90237 3.70711 8.29289L6 10.5858L12.2929 4.29289C12.6834 3.90237 13.3166 3.90237 13.7071 4.29289Z"
              fill="#696F79"
            />
          </svg>
        </button>
        <button class="cancel-btn" title="Cancel" @click="resetAddingNewContact">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM12 9.12361H4V6.87639H12V9.12361Z"
              fill="#696F79"
            />
          </svg>
        </button>
      </div>
    </td>
    <td v-if="!isAdding" />
    <td v-if="!isAdding" colspan="5">
      <div class="add-contact-container">
        <button class="add-contact-btn" @click="startAddingNewContact">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 12.5C18 12.691 17.9241 12.8741 17.7891 13.0091C17.6541 13.1441 17.471 13.22 17.28 13.22H12.72V17.78C12.72 17.971 12.6441 18.1541 12.5091 18.2891C12.3741 18.4241 12.191 18.5 12 18.5C11.809 18.5 11.6259 18.4241 11.4909 18.2891C11.3559 18.1541 11.28 17.971 11.28 17.78V13.22H6.72C6.52904 13.22 6.34591 13.1441 6.21088 13.0091C6.07586 12.8741 6 12.691 6 12.5C6 12.309 6.07586 12.1259 6.21088 11.9909C6.34591 11.8559 6.52904 11.78 6.72 11.78H11.28V7.22C11.28 7.02904 11.3559 6.84591 11.4909 6.71088C11.6259 6.57586 11.809 6.5 12 6.5C12.191 6.5 12.3741 6.57586 12.5091 6.71088C12.6441 6.84591 12.72 7.02904 12.72 7.22V11.78H17.28C17.471 11.78 17.6541 11.8559 17.7891 11.9909C17.9241 12.1259 18 12.309 18 12.5Z"
              fill="#373C44"
            />
          </svg>
          <span>Add new contact</span>
        </button>
      </div>
    </td>
    <td v-if="!isAdding" />
  </tr>
</template>

<script>
import CustomInput from '@/components/inputs/CustomInput.vue';
import CustomSelect from '@/components/inputs/CustomSelect.vue';
import debounce from '@/mixins/debounce';

export default {
  name: 'AddNewInscopeContact',
  components: {CustomInput, CustomSelect},
  mixins: [debounce],
  props: {
    existingGroups: {
      type: Array,
      default: () => [],
    }
  },
  emits: ['saveNewContact'],
  data() {
    return {
      isAdding: false,
      selectedGroup: null,
      nameInvalid: false,
      phoneInvalid: false,
      emailInvalid: false,
      newContact: {
        group: {
          id: null,
          name: ''
        },
        countryCode: '+1',
        phoneNumber: '',
        email: '',
        note: '',
      },
    };
  },
  computed: {
    formattedExistingGroups() {
      return this.existingGroups.map(group => ({
        id: group.id,
        name: group.name
      }));
    }
  },
  methods: {
    startAddingNewContact() {
      this.newContact = {
        group: {
          id: null,
          name: ''
        },
        countryCode: '+1',
        phoneNumber: '',
        email: '',
        note: '',
      };
      this.selectedGroup = null;
      this.phoneInvalid = false;
      this.emailInvalid = false;
      this.nameInvalid = false;
      this.isAdding = true;
    },

    onGroupSelect(groupName) {
      const selectedGroup = this.existingGroups.find(group => group.name === groupName);
      this.selectedGroup = selectedGroup;
      this.newContact.group = selectedGroup ? selectedGroup : {id: null, name: groupName};
      this.nameInvalid = !this.validateGroupName(groupName);
    },

    onAddNewGroup(newGroupName) {
      this.newContact.group.name = newGroupName;
      this.selectedGroup = null;
      this.nameInvalid = !this.validateGroupName(newGroupName);
    },

    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return email.trim() === '' || emailRegex.test(email);
    },

    validatePhone(phone) {
      return phone.trim() === '' || phone.length >= 7;
    },

    validateGroupName(name) {
      return name && name.trim() !== '';
    },

    updateNewContact(field, value) {
      if (field === 'countryCode') {
        value = value.replace(/[^0-9+]/g, '');
      } else if (field === 'phoneNumber') {
        value = value.replace(/[^0-9]/g, '');

        this.phoneInvalid = !this.validatePhone(value);

        if (this.validatePhone(value) || this.validateEmail(this.newContact.email)) {
          this.emailInvalid = false;
        }
      } else if (field === 'email') {
        this.emailInvalid = !this.validateEmail(value);

        if (this.validateEmail(value) || this.validatePhone(this.newContact.phoneNumber)) {
          this.phoneInvalid = false;
        }
      }

      this.$set(this.newContact, field, value);
    },

    saveNewContact() {
      this.nameInvalid = false;
      this.phoneInvalid = false;
      this.emailInvalid = false;

      let isValid = true;

      if (!this.validateGroupName(this.newContact.group.name)) {
        this.nameInvalid = true;
        isValid = false;
      }

      if (this.newContact.phoneNumber.trim() && !this.validatePhone(this.newContact.phoneNumber)) {
        this.phoneInvalid = true;
        isValid = false;
      }

      if (this.newContact.email.trim() && !this.validateEmail(this.newContact.email)) {
        this.emailInvalid = true;
        isValid = false;
      }

      if (!this.newContact.phoneNumber.trim() && !this.newContact.email.trim()) {
        this.phoneInvalid = true;
        this.emailInvalid = true;
        isValid = false;
      }

      if (!isValid) {
        return;
      }

      const newContactData = {
        name: this.newContact.group.name,
        ...(this.selectedGroup && {id: this.selectedGroup.id}),
        contacts: [{
          countryCode: this.newContact.countryCode,
          phoneNumber: this.newContact.phoneNumber,
          email: this.newContact.email,
          note: this.newContact.note
        }]
      };

      this.$emit('saveNewContact', newContactData);

      this.resetAddingNewContact();
    },

    resetAddingNewContact() {
      this.isAdding = false;
      this.selectedGroup = null;
      this.nameInvalid = false;
      this.phoneInvalid = false;
      this.emailInvalid = false;
      this.newContact = {
        name: '',
        countryCode: '+1',
        phoneNumber: '',
        email: '',
        note: '',
      };
    },
  }
};
</script>

<style scoped>
.add-contact-row td {
  padding: 10px 0;
  border-bottom: 1px solid var(--border-color);
}

.add-contact-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.add-contact-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--secondary-black-color);
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.add-contact-btn:hover {
  background-color: rgba(215, 220, 230, 0.3);
}

.add-contact-btn svg {
  flex-shrink: 0;
}

.add-contact-btn span {
  font-weight: 500;
}

.actions-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
}

.save-btn, .cancel-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.save-btn:hover, .cancel-btn:hover {
  background-color: rgba(215, 220, 230, 0.3);
}

.holder-info .info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  height: 100%;
  overflow: visible;
  padding-top: 5px;
}

.editable-cell-container {
  width: 100%;
}

.editable-cell-container input {
  width: 100%;
  border-radius: 4px;
  border: 1px solid var(--input-placeholder-value-color);
  padding: 6px 10px;
  font-size: 14px;
  color: var(--secondary-black-color);
}

.editable-cell-container input:focus {
  outline: none;
  border-color: var(--border-color);
  box-shadow: 0 0 3px rgba(0, 123, 255, 0.25);
}

.group-selection-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
